import React from 'react';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import ArrowForwardRoundedIcon from '@material-ui/icons/ArrowForwardRounded';
import FormHelperText from '@material-ui/core/FormHelperText';
import {
  Redirect,
} from 'react-router-dom'
import axios from 'axios';
import './Summoner.css';

const url = 'https://ddragon.leagueoflegends.com/cdn/10.16.1/data/en_US/champion.json';
var summoners;

export default class Summoner extends React.Component{
    constructor(props)
    {
      super(props);
      this.state = {
        value: '',
        summonersSubmitted: [],
        isLoaded: false,
        items: [],
        selectedChampID: 0,
        selectedChampName: "",
        selectedChampNameID: "",
        submitted: false,
        region: "na1",
        errorChampion: false,
        errorSummoner: false,
      };
      this.addValue = this.addValue.bind(this);
      this.updateInput = this.updateInput.bind(this);
      this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
      this.setState({ isLoaded: false });
      axios.get(url)
      .then(
      (data) => {
        this.setState({
          isLoaded: true,
          items: data.data.data,
        });
      },
      (error) => {
        this.setState({
          isLoaded: true,
          error
        });
      }
    )
    }

    addValue(evt)
    {
      evt.preventDefault();
      if (this.state.selectedChampName === "" || this.state.selectedChampName === "null"){
        this.setState({
          errorChampion: true
        })
      }else{
        if (this.state.value === undefined || this.state.value === ""){
          this.setState({
            errorSummoner: true
          })
        }
        else
        {
          this.setState({
            summonersSubmitted: [],
          });
          summoners = this.state.value.split(',');
          for (var i = 0; i < summoners.length; i++) {
              var trimmed = "";
              trimmed = summoners[i].trim();
              this.state.summonersSubmitted.push(trimmed);
          }
          var obj = {};
          obj.champ = this.state.selectedChampID;
          obj.champName = this.state.selectedChampName;
          obj.summoners = this.state.summonersSubmitted;
          obj.champNameID = this.state.selectedChampNameID;
          obj.region = this.state.region;
          fetch('https://masteryrace-api.vercel.app/api/summoner' , {
            method: "POST",
            headers: {
              'Content-type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify(obj),
          })
          .then((result) => result.json())
          this.setState({
            submitted: true
          })
        }
      }
    }

    handleChange(evt){
      this.setState({region: evt.target.value});
      console.log(this.state.region);
    }

    updateInput(evt){
      this.setState({value: evt.target.value});
    }

    render(){
      const submitted = this.state.submitted;
      const arr = []
      Object.keys(this.state.items).forEach(key => arr.push({name: this.state.items[key].name, value: this.state.items[key], nameID: key}))
      if (submitted === false){
        return(
          <div className="SummonerSearch">
            <div id = "regionselect">
              <FormControl >
                  <InputLabel >Region</InputLabel>
                  <Select
                    className = "region"
                    labelId="region"
                    value={this.state.sortedBy}
                    defaultValue = {'na1'}
                    onChange={this.handleChange}
                  >
                    <MenuItem value={'br1'}>BR</MenuItem>
                    <MenuItem value={'eun1'}>EUNE</MenuItem>
                    <MenuItem value={'euw1'}>EUW</MenuItem>
                    <MenuItem value={'jp1'}>JP</MenuItem>
                    <MenuItem value={'kr'}>KR</MenuItem>
                    <MenuItem value={'la1'}>LAN</MenuItem>
                    <MenuItem value={'la2'}>LAS</MenuItem>
                    <MenuItem value={'na1'}>NA</MenuItem>
                    <MenuItem value={'oc1'}>OCE</MenuItem>
                    <MenuItem value={'ru'}>RU</MenuItem>
                    <MenuItem value={'tr1'}>TR</MenuItem>
                  </Select>
                </FormControl>
            </div>
              
              <Autocomplete
                    id="debug"
                    options={arr}
                    getOptionLabel={(option) => option.name}
                    getOptionSelected={(option) => option.name !== 'null'}
                    style={{ width: 300 }}
                    renderInput={(params) => <TextField {...params} label="Champion" variant="outlined" />}
                    onChange={(event, newValue) => {
                      this.setState({
                        selectedChampID: newValue !== null ? newValue.value.key : 'null',
                        selectedChampName: newValue !== null ? newValue.value.name : 'null',
                        selectedChampNameID: newValue !== null ? newValue.nameID : 'null',
                      });
                    }
                  }
                />
              <form  noValidate autoComplete="off" onSubmit={this.addValue}>
                <TextField id="summoner-fill" label="Summoner names" onChange={this.updateInput} helperText="Enter summoner names in comma seperated values"/>
                <IconButton aria-label="submit" type="submit">
                  <ArrowForwardRoundedIcon />
                </IconButton>
              </form>
              <FormHelperText id="ErrorMessage1" style={{ color: '#eb5050' }}>{this.state.errorChampion ? 'Please select a champion' : ''}</FormHelperText>
              <FormHelperText id="ErrorMessage2" style={{ color: '#eb5050' }}>{this.state.errorSummoner ? 'Please enter summoner names' : ''}</FormHelperText>
          </div>
        )
      }
      return <Redirect push to="/result" />
    }
}